import React from 'react';
import { Section } from './ui/Section';
import { FadeIn } from './ui/FadeIn';
import { CheckCircle2 } from 'lucide-react';
export const WhatYouGet = () => {
  const items = ['La Guía Digital "Biblia Anti-Ansiedad" (PDF)', 'El Método de Respiración "Selah" para desbloquear el diafragma.', 'La Técnica de "Descarga en el Altar" para vencer el insomnio.', 'Mapa de Auxilio Rápido: Qué versículo leer según lo que siente tu cuerpo.', 'Checklist de Higiene Mental para guerreros pacíficos.'];
  return <Section variant="navy-light" data-id="element-152">
      <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-153">
        <div data-id="element-154">
          <FadeIn data-id="element-155">
            <h2 className="text-3xl md:text-4xl font-bold mb-8" data-id="element-156">
              Lo que recibes <span className="text-gold" data-id="element-157">hoy</span>
            </h2>
          </FadeIn>

          <div className="space-y-6" data-id="element-158">
            {items.map((item, index) => <FadeIn key={index} delay={index * 0.1} direction="up" data-id="element-159">
                <div className="flex items-start gap-4" data-id="element-160">
                  <CheckCircle2 className="w-6 h-6 text-gold flex-shrink-0 mt-1" data-id="element-161" />
                  <p className="text-lg text-cream-muted" data-id="element-162">{item}</p>
                </div>
              </FadeIn>)}
          </div>
        </div>

        <div className="flex justify-center" data-id="element-163">
          <FadeIn delay={0.3} direction="left" data-id="element-164">
            <img src="https://cdn.magicpatterns.com/uploads/ukx8oACkz4S1zWNiimhFH2/biblia_antiansiedad.png" alt="Contenido de Biblia Anti-Ansiedad" className="w-full max-w-sm object-contain drop-shadow-2xl" data-id="element-165" />
          </FadeIn>
        </div>
      </div>
    </Section>;
};